
export default {
	API: {
		URL: "https://api.boulevardautoglass.com"
	}
}
